/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceItem } from './InvoiceItem';
import {
    InvoiceItemFromJSON,
    InvoiceItemFromJSONTyped,
    InvoiceItemToJSON,
    InvoiceItemToJSONTyped,
} from './InvoiceItem';

/**
 * 
 * @export
 * @interface InvoicesMonth
 */
export interface InvoicesMonth {
    /**
     * 
     * @type {number}
     * @memberof InvoicesMonth
     */
    month: number;
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof InvoicesMonth
     */
    advance: Array<InvoiceItem>;
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof InvoicesMonth
     */
    back: Array<InvoiceItem>;
    /**
     * 
     * @type {number}
     * @memberof InvoicesMonth
     */
    suma: number;
}

/**
 * Check if a given object implements the InvoicesMonth interface.
 */
export function instanceOfInvoicesMonth(value: object): value is InvoicesMonth {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('advance' in value) || value['advance'] === undefined) return false;
    if (!('back' in value) || value['back'] === undefined) return false;
    if (!('suma' in value) || value['suma'] === undefined) return false;
    return true;
}

export function InvoicesMonthFromJSON(json: any): InvoicesMonth {
    return InvoicesMonthFromJSONTyped(json, false);
}

export function InvoicesMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicesMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'advance': ((json['advance'] as Array<any>).map(InvoiceItemFromJSON)),
        'back': ((json['back'] as Array<any>).map(InvoiceItemFromJSON)),
        'suma': json['suma'],
    };
}

export function InvoicesMonthToJSON(json: any): InvoicesMonth {
    return InvoicesMonthToJSONTyped(json, false);
}

export function InvoicesMonthToJSONTyped(value?: InvoicesMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'advance': ((value['advance'] as Array<any>).map(InvoiceItemToJSON)),
        'back': ((value['back'] as Array<any>).map(InvoiceItemToJSON)),
        'suma': value['suma'],
    };
}

